import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IAuditTrail, defaultValue } from 'app/shared/model/audit-trail.model';

const initialState: EntityState<IAuditTrail> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/audit-trail';

interface IAuditTrailQuery {
  entityName?: string;
  entityId?: number | string;
  fieldName?: string;
  action?: string;
  changedBy?: string;
  search?: string;
  from?: string; // ISO-8601 instant
  to?: string;
  page?: number; // zero based
  size?: number;
}

export const getEntities = createAsyncThunk(
  'auditTrail/fetch_entity_list',
  async ({ page = 0, size = 20, ...filters }: IAuditTrailQuery) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, String(value));
    });
    params.append('page', String(page));
    params.append('size', String(size));
    params.append('cacheBuster', String(new Date().getTime()));
    return axios.get<IAuditTrail[]>(`${apiUrl}?${params.toString()}`);
  },
  { serializeError: serializeAxiosError },
);

export const AuditTrailSlice = createEntitySlice({
  name: 'auditTrail',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;
        return { ...state, loading: false, entities: data, totalItems: parseInt(headers['x-total-count'], 10) };
      })
      .addMatcher(isPending(getEntities), state => {
        state.errorMessage = null;
        state.loading = true;
      });
  },
});

export const { reset } = AuditTrailSlice.actions;

export default AuditTrailSlice.reducer;
